import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import ScrollItem__BlockDefault from './ScrollItem__BlockDefault';
import Scene from '../3D/Scene';
import { Metrics } from '../_app/cuchillo/core/Metrics';
import Carrusel from '../_app/cuchillo/components/Carrusel';
import { GetBy } from '../_app/cuchillo/core/Element';
import gsap from 'gsap';

const HIDE_THRESHOLD = 1;

class ScrollItem__BillboardSea extends ScrollItem__BlockDefault {
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        Scene.resetSeaScroll();

        this._carrusel = new Carrusel(Metrics.WIDTH, GetBy.class("__carrusel", this.item)[0], GetBy.class("__carrusel", this.item)[1]);
        this._carrusel.multiplicator = .1;
        this._call = () => this.loop();

        this.onShow = () => {
            gsap.ticker.add(this._call);
        };

        this.onHide = () => {
            gsap.ticker.remove(this._call);
            Scene.hideRender();
        };

        this.onMove = () => {
            Scene.setSeaScroll(this.progress);
            if (this.progress > HIDE_THRESHOLD) Scene.hideRender();
            else Scene.showRender();
        };

        this.onHide = () => Scene.hideRender();
    }

    loop() {
        this._carrusel.loop();
    }

    dispose() {
        super.dispose();
        gsap.ticker.remove(this._call);
        this._carrusel.dispose();
    }
}

Scroll._registerClass('BillboardSea', ScrollItem__BillboardSea);

export default ScrollItem__BillboardSea;
